import * as React from "react";

import { RecipesContext } from "..";

export function useRecipesData(collection, key) {
  const recipes = React.useContext(RecipesContext);

  return recipes.data[collection][key];
}
